import * as React from "react";

import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { ChoiceGroup} from 'office-ui-fabric-react/lib/ChoiceGroup';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { DatePicker  } from 'office-ui-fabric-react/lib/DatePicker';
import { Label } from 'office-ui-fabric-react/lib/Label';
import {CSVLink} from 'react-csv';

/* https://www.npmjs.com/package/react-google-charts */
// import { GoogleChart } from "./classi/GoogleChart.js";

import { Config } from './Config.js';
// import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

import './css/Site.css';
import './css/Fatture.css';
import './css/Curve.css';

const sessione = new Session();
// const azioni = new Azioni();
const config = new Config();
const utils = new Utils();

const DayPickerStrings = config.getDayPickerStrings();
const firstDayOfWeek = config.getPrimoGiornoSettimana();

export class Curve extends React.Component  {
    
    constructor()
    {
        super();
        
        this.state = {
            filterDataCurDa: new Date(),
            filterDataCurA: new Date(),
            
            visualizza:'nascosto',
            divwarning:'nascosto',
            caricamentodati:'nascosto',
            
            POD:'',
            ID_SITO:'',
            PODselezionato:'',
            
            
            erroreCombo : 'Sito non selezionato',
            errorMessage:'',
            registri:[],
            registriorig:[],
            
            tipoGrafico : '',
            
            tipoOutput : '',
            tipoDettaglio : 'orario',
            tipoFlusso : 'consumo',
   
            _curve : [],
            _attiva : [],
            _reattiva : [],
   
            csvEnergiaAttiva : 'curve_attiva.csv',
            csvEnergiaReattiva : 'curve_reattiva.csv',
            
            mostraBottoneQuartodora : 'nascosto'
        }
        
        this._siti = [];

        //this._caricaGrafico = this._caricaGrafico.bind(this);
        this.popolaElencoSiti = this.popolaElencoSiti.bind(this);
        this._onSelectDateCurDa = this._onSelectDateCurDa.bind(this);
        this._onSelectDateCurA = this._onSelectDateCurA.bind(this);
        
        this._onChangeCombo = this._onChangeCombo.bind(this);
        this._onChangeOptionOutput = this._onChangeOptionOutput.bind(this);
        this._onChangeOptionDettaglio = this._onChangeOptionDettaglio.bind(this);
        this._onChangeOptionFlusso = this._onChangeOptionFlusso.bind(this);
        
        this._calcolaCurve = this._calcolaCurve.bind(this);
        this._calcolaCurveOrario = this._calcolaCurveOrario.bind(this);
        this._calcolaCurveQuartodora = this._calcolaCurveQuartodora.bind(this);
        
        this.popolaElencoSiti();
    }
    
    componentDidMount() {
        
        let today = new Date();
        let lastdaypreviosemonth = new Date( today.getFullYear() , today.getMonth(), 0 , 0, 0, 0, 0);
        let firstdaypreviosemonth = new Date( today.getFullYear() , today.getMonth()-1, 1 , 0, 0, 0, 0);
        
        if( sessione.get('filterdatacurda') !== '' && sessione.get('filterdatacurda')!=='undefined' && sessione.get('filterdatacurda')!==null ){
            firstdaypreviosemonth = new Date(sessione.get('filterdatacurda'));
        }
        
        if( sessione.get('filterdatacura') !== '' && sessione.get('filterdatacura')!=='undefined' && sessione.get('filterdatacura')!==null ){
           lastdaypreviosemonth = new Date(sessione.get('filterdatacura'));
        }
        
        if( utils.getObjInfoSocieta( 'ATTIVA_EDM_CONSUMI_GIORNO' , 'NO' ) === 'QUARTODORA' ){ this.setState({mostraBottoneQuartodora:'visualizza'}); }
        
        this.setState({id_cliente: sessione.get('id_cliente') , filterDataCurDa : firstdaypreviosemonth , filterDataCurA : lastdaypreviosemonth });
        
        utils.setBoxInfoCliente();

    }

    _calcolaCurveOrario(){
        this._calcolaCurve('orario');
    }

    _calcolaCurveQuartodora(){
        this._calcolaCurve('quartodora');
    }

    _calcolaCurve( tipoDettaglio )
    {
        
        if( this.state.POD === '')
        {
            this.setState({ visualizza:'nascosto' , divwarning:'nascosto', erroreCombo:'Sito non selezionato'});
            return;
        }

        this.setState({visualizza:'nascosto' , caricamentodati:'centrato margin10' , divwarning:'nascosto' });

        // svuota grafico
        //ReactDOM.unmountComponentAtNode(document.getElementById('grafico'));
        

        let request = new Request( config.get("anagrafica_curve"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({
                data_da: utils._onFormatDate( this.state.filterDataCurDa ), 
                data_a: utils._onFormatDate( this.state.filterDataCurA ),
                pod: this.state.POD ,
                id_sito :  this.state.ID_SITO,
                id_cliente: sessione.get('id_cliente') ,
                dettaglio : tipoDettaglio , 
                flusso : this.state.tipoFlusso , 
            })
        });


        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            if (result.success) {
                
                let _attiva = [];
                let _reattiva = [];
                let _testata = [];
                let _testataCaricata = false;
                
                _attiva.push(_testata);
                _reattiva.push(_testata);
                
                if( 'curve' in result.data )
                {
                    let _curve = result.data.curve;

                    for( let data in result.data.curve )
                    {
                        let _itema = [];
                        let _itemr = [];
                        let _testata = [];
                        
                        _testata.push('Data\\Ora');
                        _itema.push(data);
                        _itemr.push(data);

                        let chiavi = Object.keys(result.data.curve[data]).sort();

                        for( let i=0 ; i < chiavi.length ; i++ )
                        {
                            let ora = chiavi[i];

                            let EnAttiva = result.data.curve[data][ora].ATTIVA;
                            let EnReattiva = result.data.curve[data][ora].REATTIVA;
                            
                            if( typeof EnAttiva !== 'undefined' && EnAttiva !== null){
                                EnAttiva = EnAttiva.toString().replace(',','').replace('.',',');
                            }
                            
                            if( typeof EnReattiva !== 'undefined' && EnReattiva !== null){
                                EnReattiva = EnReattiva.toString().replace(',','').replace('.',',');
                            }
                            
                            _itema.push( EnAttiva );
                            _itemr.push( EnReattiva );  
                            
                            if( _testataCaricata === false ) {  _testata.push(ora); }
                        }
                        
                        if( _testataCaricata === false )
                        {
                            _attiva.push(_testata);
                            _reattiva.push(_testata);
                            _testataCaricata = true;
                        }
                        
                        
                        _attiva.push(_itema);
                        _reattiva.push(_itemr);
                        
                        
                    }

                    if( _attiva.length > 1){
                        this.setState({visualizza:'', _attiva:_attiva , _reattiva:_reattiva , _curve:_curve , divwarning:'nascosto' , caricamentodati:'nascosto' });
                        utils.vaiAId( 'scarico' );
                    }
                    else
                    {
                        this.setState({visualizza:'nascosto', _attiva:[] , _reattiva:[] , _curve:[] , divwarning:'warning centrato margin5' , caricamentodati:'nascosto' });
                    }
                }
            }
            else
            {
                this.setState({visualizza:'nascosto', _attiva:[] , _reattiva:[] , _curve:[] , divwarning:'warning centrato margin5' , caricamentodati:'nascosto'});
            }
        }.bind(this) );
 
    }
    
    _onSelectDateCurDa ( date: Date | null | undefined) {
        this.setState({ filterDataCurDa: date });
        sessione.set('filterdatacurda', date );
        
        // sul cambio della data da cambio la data a + 1 anno
        let dt = new Date( date.getFullYear() , date.getMonth()+12, 0 , 0, 0, 0, 0);
        this._onSelectDateCurA(dt);
    };
    
    _onSelectDateCurA ( date: Date | null | undefined) {
        this.setState({ filterDataCurA: date });
        sessione.set('filterdatacura', date );
    };    
    

    _onChangeCombo( option , index, value )
    {
        let errore = '';
        if( option.key==='' ) {errore = 'Sito non selezionato';}
        this.setState({POD:option.key , TIPO:option.tipo , ID_SITO:option.id_sito, erroreCombo:errore , visualizza:'nascosto' , divwarning:'nascosto', csvEnergiaAttiva: option.key+'_curve_attiva.csv', csvEnergiaReattiva: option.key+'_curve_reattiva.csv' });
        
        // svuota grafico
        //ReactDOM.unmountComponentAtNode(document.getElementById('grafico'));
    }
    
    
    _onChangeOptionOutput( event ,option )
    {
        this.setState({tipoOutput:option.key });
    }
    
    _onChangeOptionDettaglio( event ,option )
    {
        this.setState({tipoDettaglio:option.key });
    }
    
    _onChangeOptionFlusso( event ,option )
    {
        this.setState({tipoFlusso:option.key });
    }
    
    
    
    popolaElencoSiti()
    {
        var siti = sessione.get('siti');
        // console.log("SITI" , siti );
        
        var opzioni = []
        opzioni.push({ key:'' , text:'' })
        
        if( siti !== null ){
            for( let i =0; i < siti.length ; i++ )
            {
                // solo siti E.E.
                if(siti[i].TIPO === 'E' ){
                    opzioni.push({ key:siti[i].POD , tipo:siti[i].TIPO , id_sito: siti[i].SITO , text: siti[i].POD+ ' - '+siti[i].INDIRIZZO_SITO+ ' '+siti[i].NOME_COMUNE });

                    if( siti.length === 1)
                    {
                        // se esiste un solo pod lo seleziono di default
                        setTimeout(function(){
                            this.setState({POD: siti[i].POD, ID_SITO: siti[i].SITO, PODselezionato:siti[i].POD , erroreCombo:'' });
                        }.bind(this),50);
                    }

                }
            }
        }
        
        this._siti = opzioni;
    }
    
    
    render() {

        return (

            <div id="inner-container">
                <Label className='ms-fontSize-xxl titolo-pagina'>Curve<span id='boxdettagliocliente'></span></Label>


                <div id='filtri'>

                    <div className='boxsearch'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Periodo</span></label>
                        
                        <div id='ricercada'>

                            <DatePicker id='filtradatada'
                                label='Da Data'
                                firstDayOfWeek={firstDayOfWeek}
                                strings={DayPickerStrings}
                                placeholder="Seleziona una data"
                                dateFormat="DD-MM-YYYY"
                                formatDate={utils._onFormatDate}
                                locale='it'
                                value={this.state.filterDataCurDa}
                                onSelectDate={this._onSelectDateCurDa}
                                className='ms-font-m-plus'
                             />

                        </div>

                        <div id='ricercaa'>

                            <DatePicker id='filtradataa'
                                label='A Data'
                                firstDayOfWeek={firstDayOfWeek}
                                strings={DayPickerStrings}
                                placeholder="Seleziona una data"
                                dateFormat="DD-MM-YYYY"
                                formatDate={utils._onFormatDate}
                                locale='it'
                                value={this.state.filterDataCurA}
                                onSelectDate={this._onSelectDateCurA}
                                className='ms-font-m-plus'
                             />

                        </div>
                    </div>
                    
                    <div className='boxsearch'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Selezionare Sito</span></label>
                        <ComboBox
                            allowFreeform={true}
                            defaultSelectedKey=""
                            selectedKey={this.state.PODselezionato}
                            autoComplete="on"
                            options={this._siti}
                            onChanged={this._onChangeCombo}
                            errorMessage={this.state.erroreCombo}
                        />
                    </div>
                    
                    <div className='boxsearch largo33 nascosto'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Tipo di output</span></label>
                        <ChoiceGroup
                            defaultSelectedKey="M"
                            options={[ {key:'M', text:'Matrice'},{key:'C', text:'Colonna'} ]}
                            onChange={this._onChangeOptionOutput}
                            required={true}
                          />
                    </div>
                    
                    <div className='boxsearch largo33 nascosto'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Dettaglio</span></label>
                        <ChoiceGroup
                            defaultSelectedKey="orario"
                            options={[ {key:'quarto', text:'1/4 d\'ora'},{key:'orario', text:'Orario'} ]}
                            onChange={this._onChangeOptionDettaglio}
                            required={true}
                          />
                    </div>
                    
                    <div className='boxsearch largo33 ultimo nascosto'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Tipo di flusso</span></label>
                        <ChoiceGroup
                            defaultSelectedKey="consumo"
                            options={[ {key:'consumo', text:'Consumo'},{key:'immissione', text:'Immissione'} ]}
                            onChange={this._onChangeOptionFlusso}
                            required={true}
                          />
                    </div>
                    
                
                    <div className='centrato calcolacurve'>
                        <DefaultButton
                            primary={true}
                            text="Calcola Orario"
                            onClick={this._calcolaCurveOrario}
                            allowDisabledFocus={true}
                            className='mr-4'
                          />

                        <DefaultButton
                            primary={true}
                            text="Calcola Quarto D'ora"
                            onClick={this._calcolaCurveQuartodora}
                            allowDisabledFocus={true}
                            className={this.state.mostraBottoneQuartodora}
                          />
                    </div>
        
                </div>

                <div>
                    <div id='grafico'></div>
                    
                    <div id='warningdati' className={this.state.divwarning} >Dati Non Presenti</div>
                    
                    <div id='caricamento' className={this.state.caricamentodati} >... Caricamento Dati in corso ...</div>
                            
                    <div id="scarico" className={this.state.visualizza} >
                    
                        <CSVLink data={this.state._attiva} separator={";"} filename={this.state.csvEnergiaAttiva} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV curve Energia Attiva</span></CSVLink>       
                        <CSVLink data={this.state._reattiva} separator={";"} filename={this.state.csvEnergiaReattiva} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV curve Energia Reattiva</span></CSVLink>
                                
                    </div>
                </div>


            </div>
        );
    }
};
export default Curve;


// WEBPACK FOOTER //
// ./src/AcComponents/Curve.js